import { Form, Input } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import React from 'react';
import { INSTRUCTION_FREQUENCY_REGEX } from 'utils/constants';

interface FrequencyFormItemProps {
    formFieldName: NamePath;
    initialValue?: string;
    isEditing?: boolean;
    formFieldValue?: string;
    onFormChange?: (changes: {[key in string]: string}) => void;
}

const FrequencyFormItem: React.FC<FrequencyFormItemProps> = ({ formFieldName, initialValue, isEditing, formFieldValue, onFormChange }) => (
    <Form.Item
        initialValue={initialValue}
        name={formFieldName}
        rules={[
            {
                message: 'The frequency does not match the regex.',
                pattern: INSTRUCTION_FREQUENCY_REGEX,
            },
            { required: true, message: 'Required' },
        ]}
    >
        {isEditing 
            ? <Input 
                placeholder='e.g. q1h, q1d, once' 
                onChange={(e) => {
                    if (onFormChange) {
                        onFormChange({formFieldName: e.target.value})
                    }
                }} 
 
            /> 
            : <span>{formFieldValue}</span>
        }
    </Form.Item>
);

export default FrequencyFormItem;
